import React, { Component } from 'react'
import { connect } from 'react-redux'
import { StripeProvider, Elements, injectStripe } from 'react-stripe-elements'
import moment from 'moment'
import { get } from 'lodash'

import Button from 'Ui/Button'
import { notify } from 'Actions/notifications'
import { formatPrice } from 'Helpers/format-helper'

import { STRIPE_PUBLIC_KEY } from 'Config/constants'

import './annual-offer-modal.sass'


const getDiscountRateFromInterval = (interval_count) => {
  switch (interval_count) {
    case 1:
      return .25
    case 2:
      return .35
    case 3:
      return .45
    default:
      return 0
  }
}

const CheckedRadio = (
  <div className="h-[13px] w-[13px] rounded-full flex border-black border-1 justify-center items-center p-[2px]">
    <div className="h-[7px] w-[7px] rounded-full bg-black" />
  </div>
)

const UncheckedRadio = (
  <div className="h-[13px] w-[13px] rounded-full border-verylight-gray border-1" />
)
const Radio = ({ selected }) => selected
  ? CheckedRadio
  : UncheckedRadio


class AnnualOfferModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      remainingTime: this.getRemainingTime(),
      subscription: null,
      nextInvoice: null,
      changeIntervalLoading: false,
      selectedIntervalCount: 3,
    }
  }

  componentDidMount() {
    this.fetchSubscriptions()

    this.interval = setInterval(() => {
      this.setState({
        remainingTime: this.getRemainingTime()
      })
    }, 60000)
  }

  getEndDate() {
    const startDate = moment('09/05/2025', 'DD/MM/YYYY').endOf('day')
    while (moment().isAfter(startDate)) {
      startDate.add(3, 'day')
    }
    return startDate
  }

  getRemainingTime() {
    const endDate = this.getEndDate()
    return moment.duration(endDate.diff(moment()))
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  fetchSubscriptions() {
    fetch(`/api/user/subscription-details`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })
      .then(res => {
        if (res.status !== 200) throw new Error(res.error)

        return res
      })
      .then(res => res.json())
      .then(res => {
        this.setState({ subscription: res.subscription, nextInvoice: res.nextInvoice })
      })
      .catch(() =>
        this.props.dispatch(
          notify(
            'error',
            'Une erreur est survenue lors de la récupération des détails de votre abonnement.',
          ),
        ),
      )
  }

  handleChangeInterval(stripe, interval_count) {
    const { dispatch, close } = this.props
    this.setState({ changeIntervalLoading: true })

    fetch(`/api/user/change-payment-interval`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        interval: 'year',
        interval_count,
      }),
    })
      .then(res => {
        if (res.status !== 200) throw new Error(res.error)

        return res
      })
      .then(res => res.json())
      .then(res => {
        console.log('res change interval ------------------------------------------>')
        console.log(res)
        const { validated, client_secret } = res

        if (validated) {
          this.setState({ changeIntervalLoading: false })
          dispatch(notify('success', 'Changement validé.'))
          close()
        } else {
          return stripe.handleCardPayment(client_secret, {}).then(res => {
            console.log('res handleCardPayment ------------------------------------------>')
            console.log(res)
            this.setState({ changeIntervalLoading: false })

            if (res.error) {
              dispatch(
                notify(
                  'error',
                  'Changement d’offre validé, mais le paiement a été refusé, veuillez vérifier l’approvisionnement de votre carte.',
                ),
              )

              return
            }

            dispatch(notify('success', 'Changement validé.'))
          })
        }
      })
      .catch(e => {
        console.log('e ------------------------------------------>')
        console.log(e)
        this.setState({ changeIntervalLoading: false })
        this.props.dispatch(
          notify('error', 'Une erreur est survenue lors de la modification de votre abonnement.'),
        )
      })
  }

  renderIntervalRadios() {
    const { selectedIntervalCount } = this.state
    const options = [
      {
        label: '1 an',
        value: 1,
        months: '25% offerts sur l’abonnement',
      },
      {
        label: '2 ans',
        value: 2,
        months: '35% offerts sur l’abonnement',
      },
      {
        label: '3 ans',
        value: 3,
        months: '45% offerts sur l’abonnement',
      },
    ]
    return (
      <div className="flex flex-col items-center mb-4">
        <div className="">
          {options.map(option => (
            <div
              key={option.value}
              className="flex items-center mb-4 cursor-pointer"
              onClick={() => this.setState({ selectedIntervalCount: option.value })}
            >
              <Radio selected={selectedIntervalCount === option.value} />
              <div className="ml-3">
                <div className="flex items-baseline">
                  <div className="font-semibold mr-3">{option.label}</div>
                  <div className="text-center py-1 px-3 text-white text-sm rounded-[32px] bg-gradient-to-r from-new-blue to-new-blue-gradient-end">
                    Économisez {formatPrice(this.calculateDiscountedPrice(option.value).discountAmount / 100, true)}
                  </div>
                </div>
                <div className="text-new-dark-gray">{option.months}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  calculateDiscountedPrice(intervalCount) {
    const { subscription } = this.state
    const discountRate = getDiscountRateFromInterval(intervalCount)
    const monthlyPrice = subscription.items.data.reduce((acc, item) => acc + item.plan.amount, 0)
    const priceWithoutDiscount = monthlyPrice * 12 * intervalCount
    const priceWithDiscount = Math.round(priceWithoutDiscount * (1 - discountRate))

    return { priceWithoutDiscount, priceWithDiscount, discountAmount: priceWithoutDiscount - priceWithDiscount }
  }

  renderPrice() {
    const { selectedIntervalCount } = this.state
    const { priceWithoutDiscount, priceWithDiscount, discountAmount } = this.calculateDiscountedPrice(selectedIntervalCount)
    return (
      <>
        <div className="price-without">{formatPrice(priceWithoutDiscount / 100, true)}</div>
        <div className="price-with">
          {formatPrice(priceWithDiscount / 100, true)}
          <span className="indix">HT/an</span>
        </div>
        <div className="price-difference">soit {formatPrice(discountAmount / 100, true)} HT d'économies</div>
      </>
    )
  }

  render() {
    const { remainingTime, subscription, changeIntervalLoading, selectedIntervalCount } = this.state
    const { currentUser, close } = this.props

    const endDate = this.getEndDate().format('DD/MM')

    if (!currentUser.company || !subscription) return null
    
    const stripeAccount = get(this.props, 'currentUser.company.idStripeAccount')
      ? get(this.props, 'currentUser.company.idStripeAccount')
      : undefined

    const { priceWithDiscount } = this.calculateDiscountedPrice(selectedIntervalCount)

    return (
      <StripeProvider apiKey={STRIPE_PUBLIC_KEY} stripeAccount={stripeAccount}>
        <Elements locale="fr">
          <div className="AnnualOfferModal">
            <img onClick={() => close()} src="/assets/icons/icon-cross.svg" className="notif-modal-close" alt="fermer" />
            <div className="images">
              <img src="/assets/images/annual-offer-modal/euro-1.png" className="euro-1" alt="icon euro" />
              <img src="/assets/images/annual-offer-modal/euro-2.png" className="euro-2" alt="icon euro" />
              <img src="/assets/images/annual-offer-modal/euro-3.png" className="euro-3" alt="icon euro" />
              <img src="/assets/images/annual-offer-modal/calendar-1.png" className="calendar-1" alt="icon calendar" />
              <img src="/assets/images/annual-offer-modal/calendar-2.png" className="calendar-2" alt="icon calendar" />
              <img src="/assets/images/annual-offer-modal/calendar-3.png" className="calendar-3" alt="icon calendar" />
            </div>

            <div className="subtitle">
              <span className="bold">Jusqu'à 45% offerts </span>
              pour 3 ans d’abonnement
            </div>

            <div className="separator-line"/>
            {this.renderPrice()}
            
            <div className="separator-line mb-8"/>
            {this.renderIntervalRadios()}
            <div className="mb-3">
              <InjectedChangeIntervalButton
                changeIntervalLoading={changeIntervalLoading}
                onClick={stripe => this.handleChangeInterval(stripe, selectedIntervalCount)}
                label="Valider"
              />
            </div>

            <div className="small-text mb-3">Offre valable jusqu'au {endDate}</div>

            <div className="countdown-container">
              <div className="countdown-item">
                <div className="countdown-number">{remainingTime.days()}</div>
                <div className="small-text">Jours</div>
              </div>
              <div className="countdown-item">
                <div className="countdown-number">{remainingTime.hours()}</div>
                <div className="small-text">Heures</div>
              </div>
              <div className="countdown-item">
                <div className="countdown-number">{remainingTime.minutes()}</div>
                <div className="small-text">Minutes</div>
              </div>
            </div>

            <div className="small-text">
              Montant incluant la TVA : {formatPrice(priceWithDiscount * 1.2 / 100)} TTC. Le montant de votre abonnement en cours sera déduit.<br/>
              Réduction appliquée sur la première échéance.
            </div>
          </div>
        </Elements>
      </StripeProvider>
    )
  }
}

class ChangeIntervalButton extends Component {
  render() {
    const { stripe, onClick, changeIntervalLoading, label } = this.props

    return (
      <Button
        label={
          changeIntervalLoading ? (
            <img
              height="15px"
              src="/assets/images/spinner.gif"
              alt="Veuillez patienter"
              style={{margin: '0 auto'}}
            />
          ) : label
        }
        onClick={() => onClick(stripe)}
        secondaryClass="primary small-height bold"
      />
    )
  }
}

const InjectedChangeIntervalButton = connect()(injectStripe(ChangeIntervalButton))

const MapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

export default connect(MapStateToProps)(AnnualOfferModal)
